<template>
  <div class="h-full w-full" v-loading="loading" :element-loading-text="loadingText">
    <div class="flex items-center justify-between !py-3 !px-4 !border-b !border-black/10">
      <el-button
        class="bg-transparent !border !border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        @click="backToEntitiesData"
      >
        <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
      </el-button>
      <div>
        <el-select
          class="!mr-2.5 !rounded-md"
          v-model="direction"
          @change="reRenderChart"
          placeholder="Select direction"
        >
          <el-option label="Top to Bottom" value="t2b"></el-option>
          <el-option label="Bottom to Top" value="b2t"></el-option>
          <el-option label="Left to Right" value="l2r"></el-option>
          <el-option label="Right to Left" value="r2l"></el-option>
        </el-select>
        <el-button @click="expandAll()" size="small">Expand All</el-button>
        <el-button @click="collapseAll()" size="small">Collapse All</el-button>
        <el-button @click="exportToPDF()" size="small">Export as PDF</el-button>
      </div>
    </div>
    <div class="h-full w-full flex items-center justify-center" ref="chartContainer"></div>
  </div>
</template>

<script>
  import { postAPICall } from '@/helpers/httpHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import html2canvas from 'html2canvas';
  import jsPDF from 'jspdf';
  export default {
    name: 'OrgChart',
    props: {
      userHasExportPermission: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [NavigationHelper],
    data() {
      return {
        direction: 't2b',
        chartInstance: null,
        orgData: null,
        loading: true,
        loadingText: '',
      };
    },
    async mounted() {
      await this.loadOrgChartAssets();
      await this.fetchOrgChartData();
      this.assignLevels(this.orgData);
      this.initChart();
    },
    beforeDestroy() {
      if (this.chartInstance) {
        this.chartInstance.$chartContainer.remove();
        this.chartInstance = null;
      }
      Array.from(document.querySelectorAll('style[id^="org-level-"]')).forEach((el) => el.remove());
    },
    methods: {
      async loadOrgChartAssets() {
        const loadScript = (src) =>
          new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = () => resolve(script);
            script.onerror = reject;
            document.head.appendChild(script);
          });

        const loadStyle = (href) =>
          new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.href = href;
            link.rel = 'stylesheet';
            link.onload = () => resolve(link);
            link.onerror = reject;
            document.head.appendChild(link);
          });

        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js');
        await loadScript(
          'https://cdnjs.cloudflare.com/ajax/libs/orgchart/2.1.3/js/jquery.orgchart.min.js'
        );
        await loadStyle(
          'https://cdnjs.cloudflare.com/ajax/libs/orgchart/2.1.3/css/jquery.orgchart.min.css'
        );
        // await loadScript(
        //   "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"
        // );
        // await loadScript(
        //   "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"
        // );
      },
      expandAll() {
        const $ = window.jQuery;
        const $chart = $(this.$refs.chartContainer).find('.orgchart');
        const $nodesWithChildren = $chart.find('.node:has(i.edge.verticalEdge.bottomEdge)');
        const $nodesWithParent = $chart.find('.node:has(i.edge.verticalEdge.topEdge)');

        const $nodesWithLeftChild = $chart.find('.node:has(i.edge.horizontalEdge.leftEdge)');
        const $nodesWithRightChild = $chart.find('.node:has(i.edge.horizontalEdge.rightEdge)');
        console.log('node with left===>', $nodesWithLeftChild.length);
        console.log('node with right===>', $nodesWithRightChild.length);
        $nodesWithChildren.each(function () {
          const $node = $(this);

          $node.trigger('mouseenter');

          setTimeout(() => {
            const $collapseButton = $node.find('i.edge.verticalEdge.bottomEdge.fa.fa-chevron-down');
            if ($collapseButton.length > 0) {
              $collapseButton.trigger('click');
              $node.trigger('mouseleave');
            } else {
              console.warn(
                'No expand button found for node after mouseenter:',
                $node.find('.title').attr('title')
              );
            }
          }, 50);
        });
        $nodesWithParent.each(function () {
          const $node = $(this);

          $node.trigger('mouseenter');

          setTimeout(() => {
            const $collapseButton = $node.find('i.edge.verticalEdge.topEdge.fa.fa-chevron-up');
            if ($collapseButton.length > 0) {
              $collapseButton.trigger('click');
              $node.trigger('mouseleave');
            } else {
              console.warn(
                'No expand button found for node after mouseenter:',
                $node.find('.title').attr('title')
              );
            }
          }, 50);
        });
        // $nodesWithRightChild.each(function () {
        //   const $node = $(this);

        //   $node.trigger("mouseenter");

        //   setTimeout(() => {
        //     const $collapseButton = $node.find(
        //       "i.edge.horizontalEdge.rightEdge.fa.fa-chevron-right"
        //     );
        //     if ($collapseButton.length > 0) {
        //       $collapseButton.trigger("click");
        //       $node.trigger("mouseleave");
        //     } else {
        //       console.warn(
        //         "No expand button found for node after mouseenter:",
        //         $node.find(".title").attr("title")
        //       );
        //     }
        //   }, 50);
        // });
        // $nodesWithLeftChild.each(function () {
        //   const $node = $(this);

        //   $node.trigger("mouseenter");

        //   setTimeout(() => {
        //     const $collapseButton = $node.find(
        //       "i.edge.horizontalEdge.leftEdge.fa.fa-chevron-left"
        //     );
        //     if ($collapseButton.length > 0) {
        //       $collapseButton.trigger("click");
        //       $node.trigger("mouseleave");
        //     } else {
        //       console.warn(
        //         "No expand button found for node after mouseenter:",
        //         $node.find(".title").attr("title")
        //       );
        //     }
        //   }, 50);
        // });

        console.log('Expand all operation attempted.');
      },

      collapseAll() {
        const $ = window.jQuery;
        const $chart = $(this.$refs.chartContainer).find('.orgchart');
        const $nodesWithChildren = $chart.find('.node:has(i.edge.verticalEdge.bottomEdge)');

        $nodesWithChildren.each(function () {
          const $node = $(this);

          $node.trigger('mouseenter');

          setTimeout(() => {
            const $collapseButton = $node.find('i.edge.verticalEdge.bottomEdge.fa.fa-chevron-up');
            if ($collapseButton.length > 0) {
              $collapseButton.trigger('click');
            } else {
              console.warn(
                'No collapse button found for node after mouseenter:',
                $node.find('.title').attr('title')
              );
            }
          }, 50);
        });

        console.log('Collapse all operation attempted.');
      },
      exportToPDF() {
        const chartContainer = this.$refs.chartContainer;
        const chartEl = chartContainer.querySelector('.orgchart');

        if (!chartEl) {
          console.warn('Chart element not found.');
          return;
        }
        let html = chartEl.outerHTML;
        const tempWrapper = document.createElement('div');
        tempWrapper.style.position = 'fixed';
        tempWrapper.style.left = '-9999px';
        tempWrapper.style.top = '0';
        tempWrapper.innerHTML = html;
        document.body.appendChild(tempWrapper);

        const cleanedNode = tempWrapper.querySelector('.orgchart');
        document.fonts.ready.then(() => {
          html2canvas(cleanedNode, {
            backgroundColor: '#ffffff',
            useCORS: true,
            scale: 2,
          })
            .then((canvas) => {
              const imgData = canvas.toDataURL('image/png');
              const imgWidth = canvas.width * 0.2646;
              const imgHeight = canvas.height * 0.2646;
              const headingHeight = 20;

              const pdf = new jsPDF({
                orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
                unit: 'mm',
                format: [imgWidth, imgHeight + headingHeight],
              });

              const headingText = `Hierarchial Chart of ${this.orgData?.name}`;
              pdf.setFontSize(22);
              pdf.setFont('helvetica', 'bold');
              const textWidth = pdf.getTextWidth(headingText);
              const centerX = (imgWidth - textWidth) / 2;
              pdf.text(headingText, centerX, 15);

              pdf.addImage(imgData, 'PNG', 0, headingHeight);
              pdf.save(`${this.orgData?.title}-${this.orgData?.name}.pdf`);

              document.body.removeChild(tempWrapper);
            })
            .catch((err) => {
              console.error('Error capturing chart:', err);
              document.body.removeChild(tempWrapper);
            });
        });
      },
      async fetchOrgChartData() {
        try {
          this.loadingText =
            'Please wait while fetching hierarchial data based on relationships...';
          // const res = await fetch('/api/orgchart');
          // this.orgData = await res.json();
          const response = await postAPICall('POST', '/entities-hierarchy-data', {
            entity_id: this.$route.query.entity_id,
            entity_data_id: this.$route.query.entity_data_id,
          });
          this.orgData = response.data;
          console.log('this.orgChartData===>', JSON.stringify(this.orgData));
          // this.orgData = {
          //   name: "Radha Krishna All",
          //   title: "CEO",
          //   img: "",
          //   children: [
          //     {
          //       name: "Amarendra Kotipalli",
          //       title: "Project Manager",
          //       img: "",
          //       children: [
          //         {
          //           name: "Ravi Teppala",
          //           title: "Tech Lead",
          //           img: "https://i.pravatar.cc/100?img=2",
          //           children: [
          //             {
          //               name: "SaiKumar Barla",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Senior Engineer",
          //             },
          //             {
          //               name: "Durga Dileep",
          //               img: "https://i.pravatar.cc/100?img=14",
          //               title: "Senior Engineer",
          //               children: [
          //                 {
          //                   name: "Keerthana Ch",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr Engineer",
          //                 },
          //                 {
          //                   name: "Shivani Gollapalli",
          //                   img: "https://i.pravatar.cc/100?img=16",
          //                   title: "Jr Engineer",
          //                 },
          //               ],
          //             },

          //             {
          //               name: "Vibhakar Vaddi",
          //               img: "https://i.pravatar.cc/100?img=14",
          //               title: "Senior Engineer",
          //               children: [
          //                 {
          //                   name: "Sravani Ambati",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr Engineer",
          //                 },
          //                 {
          //                   name: "Laxmi Majjiga",
          //                   img: "https://i.pravatar.cc/100?img=16",
          //                   title: "Jr Engineer",
          //                 },
          //               ],
          //             },
          //             {
          //               name: "Tharuni Seru",
          //               img: "https://i.pravatar.cc/100?img=14",
          //               title: "Senior Engineer",
          //               children: [
          //                 {
          //                   name: "Mukesh Kumar",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "UI Engineer",
          //                 },
          //                 {
          //                   name: "Kavya Kalidasu",
          //                   img: "https://i.pravatar.cc/100?img=16",
          //                   title: "Jr Engineer",
          //                 },
          //               ],
          //             },

          //             {
          //               name: "Prasanna Challagali",
          //               img: "https://i.pravatar.cc/100?img=14",
          //               title: "Senior Engineer",
          //               children: [
          //                 {
          //                   name: "Arshiya Shaik",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr Engineer",
          //                 },
          //               ],
          //             },
          //             {
          //               name: "Swarna Bese",
          //               img: "https://i.pravatar.cc/100?img=14",
          //               title: "Senior Engineer",
          //               children: [
          //                 {
          //                   name: "Naga Manikanta",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr Engineer",
          //                 },
          //                 {
          //                   name: "Padmavathi Gajulaplli",
          //                   img: "https://i.pravatar.cc/100?img=16",
          //                   title: "Jr Engineer",
          //                 },
          //               ],
          //             },
          //           ],
          //         },
          //         {
          //           name: "Neeharika Shabadhu",
          //           title: "QA Lead",
          //           img: "https://i.pravatar.cc/100?img=2",
          //           children: [
          //             {
          //               name: "Balakrishna Takasi",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Sr QA Engineer",
          //             },
          //             {
          //               name: "UshaRani Alla",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Sr QA Engineer",
          //             },
          //             {
          //               name: "Balakrishna Takasi",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Sr QA Engineer",
          //               children: [
          //                 {
          //                   name: "Akhil Orusu",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr QA Engineer",
          //                 },
          //                 {
          //                   name: "Akhil Pachipala",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "Jr QA Engineer",
          //                 },
          //                 {
          //                   name: "Meghana Q",
          //                   img: "https://i.pravatar.cc/100?img=17",
          //                   title: "Jr QA Engineer",
          //                 },
          //               ],
          //             },
          //           ],
          //         },
          //         {
          //           name: "Murtaza",
          //           title: "BA Lead",
          //           img: "https://i.pravatar.cc/100?img=2",
          //           children: [
          //             {
          //               name: "Madurima Akula",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Sr BA",
          //               children: [
          //                 {
          //                   name: "Sahil Tota",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //                 {
          //                   name: "Sahithi",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //               ],
          //             },
          //             {
          //               name: "Gayatri patro",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "Sr BA",
          //               children: [
          //                 {
          //                   name: "Manasa D",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //                 {
          //                   name: "Manoj Konda",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //               ],
          //             },
          //             {
          //               name: "Venkatesh Kadiri",
          //               img: "https://i.pravatar.cc/100?img=13",
          //               title: "BA",
          //               children: [
          //                 {
          //                   name: "Suma Talluri",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //                 {
          //                   name: "Akhifa Sultana",
          //                   img: "https://i.pravatar.cc/100?img=15",
          //                   title: "BA",
          //                 },
          //                 {
          //                   name: "Meghana Q",
          //                   img: "https://i.pravatar.cc/100?img=17",
          //                   title: "BA",
          //                 },
          //               ],
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //     {
          //       name: "Mohith Sharma",
          //       img: "https://i.pravatar.cc/100?img=18",
          //       title: "PMO -AI & Connector IO",
          //       children: [
          //         {
          //           name: "Vinay Ponnaganthi",
          //           img: "https://i.pravatar.cc/100?img=19",
          //           title: "AI Trainee",
          //           children: [
          //             {
          //               name: "Durga Prasad",
          //               img: "https://i.pravatar.cc/100?img=31",
          //               title: "Jr Engineer",
          //             },
          //             {
          //               name: "Jyothi N",
          //               img: "https://i.pravatar.cc/100?img=41",
          //               title: "Jr Engineer",
          //             },
          //             {
          //               name: "Anusha Nulakana",
          //               img: "https://i.pravatar.cc/100?img=51",
          //               title: "Sr Engineer",
          //             },
          //           ],
          //         },
          //         {
          //           name: "BheemaSankar Mogali",
          //           img: "https://i.pravatar.cc/100?img=21",
          //           title: "Sr Engineer",
          //           children: [
          //             {
          //               name: "Reeshma Gumadi",
          //               img: "https://i.pravatar.cc/100?img=31",
          //               title: "Jr Engineer",
          //             },
          //             {
          //               name: "Sai Durga",
          //               img: "https://i.pravatar.cc/100?img=41",
          //               title: "Jr Engineer",
          //             },
          //             {
          //               name: "BalaGayathri M",
          //               img: "https://i.pravatar.cc/100?img=51",
          //               title: "Sr Engineer",
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // };
          this.assignLevels(this.orgData);
          this.loading = false;
        } catch (err) {
          alert('Failed to fetch org chart data.');
          console.error(err);
        }
      },
      getInitials(fullName) {
        const parts = fullName.trim().split(/\s+/);
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        if (parts.length === 2) return parts.map((p) => p.charAt(0).toUpperCase()).join('');
        return (
          parts[0].charAt(0).toUpperCase() +
          parts[1].charAt(0).toUpperCase() +
          parts[2].charAt(0).toUpperCase()
        );
      },
      backToEntitiesData() {
        let query = this.getNavigationQuery(this.$route.query);
        this.$router.push({
          path: `/entity/${this.$route.query.entity_id}`,
          query: query,
        });
      },
      injectDynamicLevelStyle(level, hueBase = 360) {
        const className = `KF-level-${level}`;
        if (document.getElementById(className)) return;
        const hue = (level * 47) % hueBase; // Slightly prime multiplier to avoid patterns
        const saturation = 65 + (level % 3) * 5; // Between 65–75%
        const lightness = 48 + (level % 2) * 6; // Between 48–54%

        const bg = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        const border = `hsl(${hue}, ${saturation}%, ${lightness - 10}%)`;

        const style = document.createElement('style');
        style.id = className;
        style.textContent = `
    .orgchart .${className} .title {
      background-color: ${bg} !important;
    }
    .orgchart .${className} .content {
      border-color: ${border} !important;
    }
  `;
        document.head.appendChild(style);
      },

      assignLevels(node, level = 0) {
        node._level = level;
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => this.assignLevels(child, level + 1));
        }
      },
      initChart() {
        const $ = window.jQuery;
        $(this.$refs.chartContainer).orgchart({
          data: this.orgData,
          direction: this.direction, // 👈 Choose: 't2b', 'b2t', 'l2r', or 'r2l'
          nodeContent: 'title',
          draggable: true,
          pan: true,
          // exportButton: true, // optional built-in button
          // exportFilename: "OrgChart",
          // exportFileextension: "png",
          //zoom:true,
          // zoominLimit: 7,
          // zoomoutLimit: 0.5,
          createNode: ($node, data) => {
            const level = data._level || 0;
            let hueBase = ((level + 1) * 60) % 360 || 360;
            const className = `KF-level-${level}`;
            const hue = (level * 47) % hueBase;
            const saturation = 65 + (level % 3) * 5;
            const lightness = 48 + (level % 2) * 6;

            this.injectDynamicLevelStyle(level, hueBase);
            $node.addClass(className); // Add class to root node wrapper

            const rotation = this.getAvatarRotation(this.direction);
            const avatarClass = `avatar image-avatar rotate-${this.direction}`;

            let avatarHTML = '';
            if (data.img && data.img.trim()) {
              avatarHTML = `<img class="${avatarClass}" src="${data.img}" alt="${data.name}" style="transform: ${rotation};width:40px;height:40px;border-radius:50%;margin-bottom:4px;" />`;
            } else {
              const initials = this.getInitials(data.name);
              avatarHTML = `<div style="with:100%;text-align:center;"><div class="avatar initials-avatar rotate-${
                this.direction
              }" style="transform: ${rotation}; width:40px;height:40px;border-radius:50%;margin-bottom:4px;background-color: hsl(${hue}, ${saturation}%, ${
                lightness - 10
              }%) !important;  border: 1px solid hsl(${hue}, ${saturation}%, ${lightness}%) !important;display: inline-block;">
             <p class="circle-inner" style="color: white;display: table-cell;vertical-align: middle;text-align: center;text-decoration: none;height: 40px;width: 40px;font-size: 16px;"> ${initials}</p>
              </div></div>`;
            }

            // const wrapper = document.createElement("div");
            // wrapper.className = "node-wrapper";
            // wrapper.innerHTML = avatarHTML + $node.html();
            // $node.html(wrapper);
            $node.find('.title').attr('title', data.name);
            $node.find('.title').before(`
  <div class="avatar-wrapper" style="text-align:center;">${avatarHTML}</div>
`);
            // $node.prepend(avatarHTML);
            $node.css({ opacity: 0 }).animate({ opacity: 1 }, 400);
          },
          dropCriteria: (draggedNode, dragZone, dropZone) => {
            const draggedData = $(draggedNode[0]).data('nodeData');
            const dropData = $(dropZone[0]).data('nodeData');

            const draggedLevel = draggedData?._level;
            const dropLevel = dropData?._level;

            return dropLevel === draggedLevel - 1;
          },
          //visibleLevel: 2,
        });

        // this.chartInstance = chart.data('orgchart');

        // $(this.$refs.chartContainer).on('nodedrop.orgchart', () => {
        //   const updatedHierarchy = this.chartInstance.getHierarchy();
        //   console.log('Updated hierarchy:', updatedHierarchy);
        //   this.sendHierarchyToApi(updatedHierarchy);
        // });

        const chartEl = this.$refs.chartContainer.querySelector('.orgchart');
        if (chartEl) {
          this.chartInstance = $(chartEl).data('orgchart');
          console.log('Chart', this.chartInstance);
          $(chartEl).on('nodedrop.orgchart', (event, extraParams) => {
            const draggedData = $(extraParams.draggedNode[0]).data('nodeData');
            const dropData = $(extraParams.dropZone[0]).data('nodeData');

            this.updateEntityHierarchyData(draggedData, dropData);
          });
        }
      },
      async updateEntityHierarchyData(draggedData, dropZone) {
        try {
          this.loading = true;
          this.loadingText = 'Please wait while updating hierarchial data...';
          const response = await postAPICall('PUT', '/update-entity-hierarchy-data', {
            child_entity_data: draggedData,
            parent_entity_data: dropZone,
            entity_id: this.$route.query.entity_id,
          });
          if (response.success) {
            await postAPICall(
              'PATCH',
              `/templates-data/${response.data.entity_data_id}/${response.data.template_id}`,
              response.data
            );
            await this.fetchOrgChartData();
            this.reRenderChart();
            this.loading = false;
          }
        } catch (err) {
          console.error('API failed:', err);
        }
      },
      getAvatarRotation(direction) {
        switch (direction) {
          case 'r2l':
            return 'rotate(-90deg)';
          case 'l2r':
            return 'rotateY(180deg) rotateZ(90deg)';
          case 'b2t':
            return 'rotate(180deg)';
          case 't2b':
          default:
            return 'rotate(0deg)';
        }
      },

      async sendHierarchyToApi(data) {
        try {
          await fetch('/api/orgchart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });
          alert('Hierarchy updated successfully.');
        } catch (err) {
          alert('Failed to update hierarchy.');
          console.error(err);
        }
      },

      reRenderChart() {
        window.jQuery(this.$refs.chartContainer).empty();
        this.initChart();
      },
      adjustAlignment(direction) {
        const container = this.$refs.chartContainer;
        switch (direction) {
          case 'l2r':
            container.style.textAlign = 'left';
            break;
          case 'r2l':
            container.style.textAlign = 'right';
            break;
          case 't2b':
          case 'b2t':
          default:
            container.style.textAlign = 'center';
        }
        this.$nextTick(() => {
          const chartEl = container.querySelector('.orgchart');
          if (chartEl) {
            chartEl.style.margin = '0 auto';
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .orgchart {
    background: #fff !important;

    .l2r,
    .r2l {
      position: unset;
    }
  }
</style>

<style lang="scss" scoped>
  .el-button:focus,
  .el-button:hover {
    color: white !important;
    border-color: var(--brand-500);
    background-color: var(--brand-500);
  }

  .orgchart td.left,
  .orgchart td.right,
  .orgchart td.top {
    border-color: #aaa;
  }

  .orgchart td > .down {
    background-color: #aaa;
  }

  .chart-toolbar button[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
  }

  .image-avatar {
    object-fit: cover;
  }

  .initials-avatar {
    background-color: #999;
    color: white;
  }
</style>
